export var PropertyHeadingEnum;
(function (PropertyHeadingEnum) {
    PropertyHeadingEnum["ErfNumber"] = "Erf number";
    PropertyHeadingEnum["Address"] = "Address";
    PropertyHeadingEnum["SGCode"] = "SG code";
    PropertyHeadingEnum["Allotment"] = "Allotment";
    PropertyHeadingEnum["FarmNumber"] = "Farm number";
    PropertyHeadingEnum["PtnNumber"] = "Portion number";
    PropertyHeadingEnum["PropertyDescription"] = "Property description";
    PropertyHeadingEnum["OwnerName"] = "Owner name";
    PropertyHeadingEnum["OwnerSurname"] = "Owner surname";
    PropertyHeadingEnum["OwnerIDNumber"] = "Owner ID number";
    PropertyHeadingEnum["OwnerOrganisation"] = "Organisation";
    PropertyHeadingEnum["OwnerOrganisationRegNo"] = "Organisation Reg. No.";
    PropertyHeadingEnum["OwnerRepresentative"] = "Representative";
    PropertyHeadingEnum["Zoning"] = "Zoning";
    PropertyHeadingEnum["Cemetery"] = "Cemetery";
    PropertyHeadingEnum["PlotNumber"] = "Plot number";
    PropertyHeadingEnum["GraveID"] = "Grave Id";
    PropertyHeadingEnum["Capacity"] = "Grave capacity";
    PropertyHeadingEnum["MarkerType"] = "Marker type";
    PropertyHeadingEnum["Condition"] = "Condition of grave";
    PropertyHeadingEnum["GraveStatus"] = "Grave status";
    PropertyHeadingEnum["SectionalTitleID"] = "Sectional title Id";
    PropertyHeadingEnum["UnitNumber"] = "Unit number";
})(PropertyHeadingEnum || (PropertyHeadingEnum = {}));
export var PropertySearchOption;
(function (PropertySearchOption) {
    PropertySearchOption["Property"] = "Property";
    PropertySearchOption["PropertyOwner"] = "Owner";
    PropertySearchOption["PropertyZoning"] = "Zoning";
    PropertySearchOption["SectionalTitle"] = "Sectional title";
})(PropertySearchOption || (PropertySearchOption = {}));
